import React, { useEffect } from "react";
import slider1 from "../images/slider1.webp";
import slider2 from "../images/slider2.jpg";
import slider3 from "../images/slider4.webp";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import MinNavbar from "../nav/MinNavbar";
import "./HomeCarousel.css";
import ShopByCategory from "../category/ShopByCategory";

const HomeCarousel = () => {
  useEffect(() => {
    const bootstrap = require("bootstrap/dist/js/bootstrap.bundle.min.js");
    const carouselElement = document.querySelector(
      "#carouselExampleAutoplaying"
    );
    if (carouselElement) {
      new bootstrap.Carousel(carouselElement, {
        interval: 5000,
        ride: "carousel",
        pause: false,
        wrap: true,
      });
    }
  }, []);

  return (
    <>
      <div className="carousel-container" id="home">
        <div className="navbar-overlay">
          <MinNavbar />
        </div>

        <div
          id="carouselExampleAutoplaying"
          className="carousel slide carousel-fade"
        >
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img
                src={slider2}
                className="d-block w-100 img-fluid"
                alt="Slide 1"
              />
              <div className="carousel-caption text-left">
                <h1>Eat Green. Live Clean.</h1>
                <p>Shop sustainable, eat responsibly</p>
                <a href="#products">
                  <button className="btn btn-success mt-3">Explore Now</button>
                </a>
              </div>
            </div>
            <div className="carousel-item">
              <img
                src={slider1}
                className="d-block w-100 img-fluid"
                alt="Slide 2"
              />
              <div className="carousel-caption text-left">
                <h1>Welcome to Nature's Market</h1>
                <p>Organic. Fresh. Handpicked for you.</p>
                 <a href="#products">
                  <button className="btn btn-success mt-3">Explore Now</button>
                </a>
              </div>
            </div>
            <div className="carousel-item">
              <img
                src={slider3}
                className="d-block w-100 img-fluid"
                alt="Slide 3"
              />
              <div className="carousel-caption text-left">
                <h1>Pure Ingredients</h1>
                <p>Only the best from our farms to your table</p>
                 <a href="#products">
                  <button className="btn btn-success mt-3">Explore Now</button>
                </a>
              </div>
            </div>
          </div>

          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleAutoplaying"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true" />
            <span className="visually-hidden">Previous</span>
          </button>

          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleAutoplaying"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true" />
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
      {/* <ShopByCategory/> */}
    </>
  );
};

export default HomeCarousel;
